module.exports = __webpack_public_path__ + "static/media/imgSelfProductionBenefits3.02fbee18.png";